import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Action } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { IAppState } from "../../../redux/reducers";
import MoreOptions from "../more-options";
import { IPopupMenuOption } from "../popup-menu";
import { iamEntityActions } from "redux/actions/iam-entity";
import { IIAMEntity } from "api/entities/iam-entity";
import { useNavigate } from "react-router-dom";

const mapDispatchToProps = (
  dispatch: ThunkDispatch<IAppState, void, Action>
) => {
  return {
    openDeleteConfirmation: (id: string) =>
      dispatch(iamEntityActions.deleteConfirmation.open(id)),
  };
};

export interface IMoreOptionProps
  extends ReturnType<typeof mapDispatchToProps> {
  data: IIAMEntity;
  routeGetter: (id: string) => string
}

export const MoreOption = connect(
  null,
  mapDispatchToProps
)((props: IMoreOptionProps) => {
  const [options, setOptions] = useState<IPopupMenuOption[]>(getOptions());
    const navigate = useNavigate()

  function openDeleteConfirmation() {
    props.openDeleteConfirmation(props.data.id);
  }

  function getOptions(): IPopupMenuOption[] {
    const result = [
      {
        label: "Manage",
        onClick: () =>
          navigate(props.routeGetter(props.data.id)),
      },
      {
        label: "Delete",
        onClick: openDeleteConfirmation,
      },
    ];

    return result;
  }

  useEffect(() => {
    setOptions(getOptions());

    // eslint-disable-next-line
  }, []);

  return <MoreOptions options={options} />;
});
